export const CLIENT = 'client';
